import React from "react";
import ProviderTable from "src/pages/setting/provider";

export default function ProviderPage() {
  return <ProviderTable />;
}
